// removed by extract-text-webpack-plugin
module.exports = {"has-value":"root__has-value___22rTl","is-clearable":"root__is-clearable___3oP40","Select--single":"root__Select--single___2USHI","Select-control":"root__Select-control___1FawQ","Select-value":"root__Select-value___3j_g-"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/root.css
// module id = 1028
// module chunks = 0